import { useEffect } from "react";

// Note: This hook is used to set the robots meta tag to "noindex, nofollow" for a specific page.
// It ensures that the page is not indexed by search engines and does not follow links on the
// The react-helmet-async is not supporting react 19 yet, so we are using a custom implementation.
export const useRobotsIgnorePage = () => {
  useEffect(() => {
    let metaTag = document.querySelector('meta[name="robots"]');

    if (metaTag) {
      metaTag.setAttribute("content", "noindex, nofollow");
    } else {
      metaTag = document.createElement("meta");
      (metaTag as HTMLMetaElement).name = "robots";
      (metaTag as HTMLMetaElement).content = "noindex, nofollow";
      document.head.appendChild(metaTag);
    }

    return () => {
      if (metaTag) {
        metaTag.setAttribute("content", "index, follow");
      }
    };
  }, []);

  return {};
};
